<template>
    <div>
        <div class="display-inline" v-on:click="noticeModal($event)">
            <slot name="modal-link"></slot>
        </div>
        <modal :show.sync="modals.classic" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Upload Documents</h4>
            <hr />
            <div class="container">
                <!-- Browse Button -->
                <div class="row">
                    <div class="col-md-7">
                        <label>Please select a document to upload:<br>
                            <small class="red">*PDF/PNG/JPG/JPEG Document files with a size less than 10MB</small>
                        </label>
                    </div>
                    <div
                        class="col-md-5 d-flex justify-content-end more-top-padding more-bottom-padding no-right-padding">
                        <base-button type="file">
                            <span><i class="tim-icons icon-laptop"></i> Browse</span>
                            <input accept=".pdf,.png,.jpg,.jpeg" :error="getError('file')" name="file" type="file"
                                @change="setUploadedFile" />
                        </base-button>
                    </div>
                </div>
                <!-- Selected File -->
                <div v-if="document.file" class="row">
                    <div class="col-md-3">
                        <label>Selected File</label>
                    </div>
                    <base-input v-model="document.file.target.files[0].name" class="col-md-9" type="text"
                        placeholder="No file selected" addon-left-icon="tim-icons icon-attach-87" disabled></base-input>
                </div>

                <base-input>
                    <label>Types </label>
                    <v-select v-model="document.type" name="type" label="name" :reduce="types => types.id"
                        :options="userFileTypes" placeholder="Select one"></v-select>
                </base-input>

                <base-input>
                    <label>Remark</label>
                    <textarea class="form-control" placeholder="(Optional) Add notes about this document..." rows="3"
                        v-model="document.remark"></textarea>
                </base-input>
            </div>
            <template slot="footer">
                <div class="container alert_footer">
                    <base-button type="danger" @click.native="modals.classic = false" class="mr-4">
                        <span><i class="tim-icons icon-simple-remove"></i> Cancel</span>
                    </base-button>
                    <base-button type="primary" @click.native="submit">
                        <span><i class="tim-icons icon-cloud-upload-94"></i> {{ savingDocument ? "Saving..." : "Upload"
                            }}</span>
                    </base-button>
                </div>
            </template>
        </modal>

    </div>
</template>

<script>
import {
    BaseButton,
    Modal
} from '@/components'
import {
    Upload
} from 'element-ui'
import swal from "sweetalert2";

const options = {
    'Content-Type': 'application/json',
    config: { showToast: false }
};

export default {
    name: "UserDocumentsModal",
    props: {
        email: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        document: {
            type: Object,
            default: function () {
                return {
                    id: 0,
                    file: null,
                    type: null,
                    remark: ""
                }
            }
        },
        isIcon: {
            type: Boolean,
            default: false
        },
        isNew: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modals: {
                classic: false,
            },
            userFileTypes: [],
            savingDocument: false,
        };
    },
    components: {
        BaseButton,
        Modal,
        Upload
    },
    computed: {
        fileRule() {
            return this.isNew ? 'required' : ''
        }
    },
    methods: {
        noticeModal: function (event) {
            this.openModal()
        },
        openModal() {
            let ctx = this;
            ctx.getUserFileTypes().then(() => {
                ctx.modals.classic = true
            })
        },
        async getUserFileTypes() {
            const response = await this.axios.get("/api/applicationuserfiletypes");
            this.userFileTypes = response.data.sort(function (a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        },
        setUploadedFile(e) {
            var files = e.target.files
            var extension = files[0].type
            if (extension != "application/pdf" && extension != "image/png" && extension != "image/jpeg" && extension != "image/jpg") {
                this.$toast.error("Invalid File Format (Please upload PDF/PNG/JPG/JPEG Document files with a size less than 10M)");
                return
            } else {
                this.document.file = e
            }
        },
        showLoadingSweetAlert(message) {
            swal({
                position: "top-end",
                icon: "warning",
                title: "Please Wait Patiently",
                html: message,
                timer: 10000,
                showConfirmButton: false,
            });
        },
        showLoadingSweetAlert(message) {
            new swal({
                position: "top-end",
                icon: "warning",
                title: "Please Wait Patiently",
                html: message,
                timer: 10000,
                showConfirmButton: false,
            });
        },
        submit(e) {
            let ctx = this;
            this.savingDocument = true;
            this.showLoadingSweetAlert(
                "Your document is uploading.<br><br>This message will disappear automatically in 10 seconds."
            );
            ctx.$validator.validateAll().then((result) => {
                if (result) {
                    ctx.saveFile(ctx.$route.params.id)
                        .then(response => {
                            ctx.modals.classic = false

                            ctx.document.file = null
                            ctx.document.type = null
                            ctx.$emit("reloadDocuments")
                            ctx.$toast.success('Docuement added successfully.');
                        })
                        .catch((error) => {
                            // Display the actual error message from the API
                            const errorMessage = error.response?.data || "Error uploading document";
                            ctx.$toast.error(errorMessage);
                        });
                }
            })
        },
        saveFile() {
            let ctx = this;
            //const localStore = JSON.parse(localStorage.getItem("user"));
            let formData = new FormData();
            formData.append('IFile', ctx.document.file.target.files[0]);
            // formData.append('Id', this.document.id)
            if (ctx.email) {
                formData.append('Email', ctx.email)
            }
            this.savingDocument = false;
            formData.append('Remark', ctx.document.remark)
            formData.append('FileTypeId', ctx.document.type)
            formData.append('DocumentDate', new Date().toISOString())

            // for user profile/regristrations we just want to allowe the urer end point
            // for everyone else pass through the admin validations
            // if no type is passed we also assum its personal
            let url = (!this.type || this.type === "personal")
                ? `api/applicationuserfiles/user/` : `api/applicationuserfiles/admin`;

            return ctx.axios.post(url, formData, options)



        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        }
    }
}
</script>
